import { createRecoilAtomKeys } from '@app/recoil';
import { atom, selector } from 'recoil';

const parentGrouping = 'favoritedProducts';

enum StateProps {
  List = 'List',
  DataState = 'DataState',
}

const keys = createRecoilAtomKeys<typeof parentGrouping, StateProps>(
  parentGrouping,
  Object.values(StateProps),
);

export const favoriteDataState = atom<Record<string, boolean>>({
  key: keys[parentGrouping].DataState.atom,
  default: {},
});

const favoritedProductsList = selector<Record<string, boolean>>({
  key: keys[parentGrouping].List.atom,
  get: ({ get }) => get(favoriteDataState),
  set: ({ set }, updatedProduct) => {
    set(favoriteDataState, (prevProducts) => ({
      ...prevProducts,
      ...updatedProduct,
    }));
  },
});

export default favoritedProductsList;
